export const apiBaseUrl = window.location.protocol === 'https:' ? 'https://testbenchv4.torcai.com' : 'https://testbenchv4.torcai.com';
export const apiFileUploadBaseUrl = 'https://testbenchv4.torcai.com/atd';
export const authBaseUrl = 'https://testbenchv4.torcai.com';
export const demoTenantBaseUrl = "https://atdtestdemo.torcai.com";
export const timestampBaseUrl = 'https://testbenchv4.torcai.com/atd'
export const version = '1.0.0';
export const domain = 'torcai.in';
export const constants = {};
export const tenantIdsToShowDemoData = [];

// export const soundTrackBaseUrl = window.location.protocol === 'https:' ? 'https://stagepublisherV2.torcai.com' : 'http://stagepublisherV2.torcai.com';
export const soundTrackBaseUrl = window.location.protocol === 'https:' ? 'https://stageatdv2.torcai.com' : 'https://stageatdv2.torcai.com';

export const endPoints = {
  atd: '/report-atd',
  // atdDashboard : '/report-atd/dashboard',
  tai: '/tai/solr',
  atdDashboard: '/druid/dashboard',
  auth: '/auth/v3',
  geo: '/tai/geo/torcai',
  bidder: '/bidder/report',
  io: '',
  campaign: '/campaign',
  audience:'/audience',
  campaignPmp: '',
  creative: '/creative',
  medialist: '',
  data: '/data',
  ionReport: '',
  adUnitBulk: '',
  adUnitMap: '',
  mediation: '',
  pmp: '',
  adgroup: '',
  adunit: '',
  payment: "/payment",
  fb: '',
  subscription: '/subscription',
  tiktok:'',
  dataConfig:'/dataconfig',
  variable:'/variable',
  beki:'beki'
}
export const cdnUrl = window.location.protocol === 'https:' ? 'https://d1g8vw470g7bmg.cloudfront.net' : 'http://d1g8vw470g7bmg.cloudfront.net';

export const CONTEXT = '/atd';
export const torcaiTracking = ''
export const tomcatApiUrl = '';
export const iFrameApiUrl = '';
export const imageApiUrl = '';